module.exports = __webpack_public_path__ + "img/boat_transport.3fe4e5ce.png";